module.exports = __webpack_public_path__ + "img/icon-user-2.5c1222ba.svg";